import { fetchList } from './fetchLists';
import { GET_OBJECTIONS_TYPES } from 'src/api/graphql/queries/objectionsTypes.gql';

export const getObjectionsTypes = async () => {
	return fetchList({
		query: GET_OBJECTIONS_TYPES,
	});
};
